import { Box, Grid, Typography } from "@mui/material";
import PageSection from "components/shared/PageSection";
// assets
import PurpleStationBackground from "assets/images/page-backgrounds/bg-purple-station.jpg";

/**
 * * The Science page of the Platform section
 * @returns {React.ReactElement} TheSciencePage
 */
export default function TheSciencePage() {
  return (
    <Grid container columns={16}>
      <Grid item xs={16} md={10} lg={9}>
        <PageSection
          id="platform-section-TheScience"
          sx={{
            px: { xs: 1, sm: 5, md: 10 },
            backgroundColor: { xs: "#000a", md: "black" },
          }}
          backgroundSx={{
            backgroundImage: `url(${PurpleStationBackground})`,
            backgroundPositionX: "50%",
            backgroundPositionY: "60%",
            backgroundPosition: "cover",
            minWidth: "100%",
          }}
        >
          <Box display="flex" flexDirection="column">
            <SectionText />
          </Box>
        </PageSection>
      </Grid>
      <Grid item xs={16} md={6} lg={7}>
        <Box height="100%" width="100%">
          <Box
            sx={{
              backgroundImage: `url(${PurpleStationBackground})`,
              backgroundAttachment: "fixed",
              width: "100%",
              height: "100%",
              backgroundPositionX: "-150%",
            }}
          />
        </Box>
      </Grid>
    </Grid>
  );
}

/**
 * * Text for the The Science page
 * @param {Object} props
 * @returns {React.ReactElement} SectionText
 */
function SectionText(props) {
  return (
    <>
      <Typography variant="h2" {...props}>
        The science
      </Typography>
      <Typography variant="body1" py={1} {...props}>
        Early cancer detection and treatment is the best defense against cancer
        mortality... and finding cancer early has never been more critical. In
        recent years, there has been a fundamental shift in our understanding of
        how cancer progresses as a disease. Conventional thinking suggests that
        cancer cells spread once a tumor has formed. However, recent studies
        have revealed that cancer cells actually disseminate into the
        bloodstream before the primary tumor has been discovered and lay dormant
        only to re-emerge years later in another area of the body. This could
        explain one reason patients who initially appear cancer-free after a
        long and difficult battle later present with cancer.
      </Typography>
    </>
  );
}
